import Divider from "antd/lib/divider";
import type { Props } from "./types";

const DividerWrapper = ({ ...props }: Props): JSX.Element => {
  return <Divider {...props} />;
};

export default DividerWrapper;
